export * from './configuration-resolver';
